import { useEffect, useState } from 'react';

import { MOBILE_SCREEN_SIZE } from '@/constants';

export const useMobileScreen = () => {
  const [mobileScreen, setMobileScreen] = useState<boolean | null>(null);
  // Check if mobile on resize
  useEffect(() => {
    const handleResize = () => {
      window.innerWidth < MOBILE_SCREEN_SIZE ? setMobileScreen(true) : setMobileScreen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Check if mobile on load
  useEffect(
    () => (window.innerWidth < MOBILE_SCREEN_SIZE ? setMobileScreen(true) : setMobileScreen(false)),
    []
  );
  return mobileScreen;
};
